import {Component} from '@angular/core';
import {ViewController} from "ionic-angular";
import {DifficultyRoute, DifficultyVia, SearchFilter, SectorType} from "../../models/data.model";
import {DataProvider} from "../../providers/data/data";
import {ToastProvider} from "../../providers/toast/toast";

@Component({
  selector: 'site-form',
  templateUrl: 'site-form.html'
})
export class SiteFormComponent {

  formData: SearchFilter;

  constructor(private viewCtrl: ViewController,
              private data: DataProvider,
              public toast: ToastProvider) {

    this.formData = JSON.parse(JSON.stringify(this.data.getSearchFilter()));
    if (!this.isPosition()) this.formData.isDistance = false;
  }

  protected isPosition(): boolean {
    return this.data.isPosition();
  }

  protected updateLocation() {
    this.data.updateLocation()
      .then(() => {
        if (this. isPosition()) {
          this.formData.isDistance = true;
        }
      }).catch(err => {
        this.formData.isDistance = false;
      this.toast.errorToast("Localisation indisponible");
    });
  }

  protected getDifficultiesRoute(): DifficultyRoute[] {
    return Object.keys(DifficultyRoute).map(c => DifficultyRoute[c]);
  }

  protected getDifficultiesVia(): DifficultyVia[] {
    return Object.keys(DifficultyVia).map(c => DifficultyVia[c]);
  }

  protected getSectorTypes(): SectorType[] {
    return Object.keys(SectorType).map(c => SectorType[c]);
  }

  protected getSectorTypeKeyFromValue(sectorTypeValue: string): string {
    return Object.keys(SectorType).find(sectorType => {
      return sectorTypeValue == SectorType[sectorType];
    });
  }

  protected closeModal(saveForm: boolean ) {
    if (saveForm) this.data.setSearchFilter(this.formData);
    this.viewCtrl.dismiss().catch();
  }

  protected getLowerDifficultyRouteLabel(): String {
    return this.getDifficultiesRoute()[this.formData.difficultyRoute.lower];
  }

  protected getUpperDifficultyRouteLabel(): String {
    return this.getDifficultiesRoute()[this.formData.difficultyRoute.upper];
  }

  protected getLowerDifficultyViaLabel(): String {
    return this.getDifficultiesVia()[this.formData.difficultyVia.lower];
  }

  protected getUpperDifficultyViaLabel(): String {
    return this.getDifficultiesVia()[this.formData.difficultyVia.upper];
  }

  protected toggleDifficultyRoute() {
    if (this.formData.isDifficultyRoute) {
      this.activateFilterSectorType(SectorType.SchoolCliff);
      this.activateFilterSectorType(SectorType.LongRoute);
    }
  }

  protected toggleDifficultyVia() {
    if (this.formData.isDifficultyVia) this.activateFilterSectorType(SectorType.ViaFerrata)
  }

  private activateFilterSectorType(sectorTypeToActivate: SectorType) {
    this.formData.isSectorType = true;
    Object.keys(SectorType).forEach((sectorType: SectorType) => {
      if (SectorType[sectorType] == sectorTypeToActivate) this.formData.sectorType[sectorType] = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/site-form/site-form.ts